import { httpRequest } from "../../http";

export class CommandFetchTemplates {
    async run(notebookId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}/pages/?type=template&parent=null`;
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response as any[];
        } catch (error) {
            console.error('Error fetching templates:', error);
            throw error;
        }
    }
}
